"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportAPI = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ReportAPI = /*#__PURE__*/function () {
  function ReportAPI(_ref) {
    var customerKey = _ref.customerKey;
    (0, _classCallCheck2.default)(this, ReportAPI);
    this.customerKey = null;
    this.requestAuth = null;
    this.requestParameters = null;
    this.helper = new _helper.Helper();
    this.customerKey = customerKey;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.customerKey);
  }

  (0, _createClass2.default)(ReportAPI, [{
    key: "getLMDLoadPlanReport",
    value: function getLMDLoadPlanReport(param, payload) {
      return this.requestAuth.post('AI_REPORT', "loadplan", _objectSpread(_objectSpread({}, this.requestParameters), param), payload);
    }
  }, {
    key: "getLMDTruckSummaryReport",
    value: function getLMDTruckSummaryReport(param, payload) {
      return this.requestAuth.post('AI_REPORT', "trucksummary", _objectSpread(_objectSpread({}, this.requestParameters), param), payload);
    }
  }, {
    key: "getMRLatenessReport",
    value: function getMRLatenessReport(param, payload) {
      return this.requestAuth.post('AI_REPORT', "offtimeschedule", _objectSpread(_objectSpread({}, this.requestParameters), param), payload);
    }
  }, {
    key: "getMRLatenessDashboard",
    value: function getMRLatenessDashboard(param) {
      return this.requestAuth.get('AI_ROUTE_DASHBOARD', "offtimeschedule", _objectSpread(_objectSpread({}, this.requestParameters), param));
    }
  }, {
    key: "getMRSummaryDashboard",
    value: function getMRSummaryDashboard(param) {
      return this.requestAuth.get('AI_ROUTE_DASHBOARD', "calendarschedule", _objectSpread(_objectSpread({}, this.requestParameters), param));
    }
  }]);
  return ReportAPI;
}();

exports.ReportAPI = ReportAPI;